import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isValidSEOUrl, sanitizeSEOUrl } from '@/utils/seoUrlValidator';
import { normalizePathForSEO } from '@/utils/urlCleaner';

/**
 * Middleware qui intercepte la navigation et valide/corrige les URLs
 * Redirige vers 404 les URLs malformées
 * Normalise les doubles préfixes de langue
 */
export const URLSanitizationMiddleware = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Autoriser explicitement les routes admin
    if (currentPath.startsWith('/admin')) {
      return;
    }
    
    // Vérifier si l'URL est valide
    if (!isValidSEOUrl(currentPath)) {
      console.warn('❌ URL invalide détectée:', currentPath);
      navigate('/404', { replace: true });
      return;
    }

    // Normaliser le path (corriger doubles préfixes langue, /games/ → /game/, etc.)
    const normalizedPath = normalizePathForSEO(currentPath);
    
    // Si le path a été modifié, rediriger vers la version normalisée
    if (normalizedPath !== currentPath) {
      console.log('🔄 Normalisation URL:', currentPath, '→', normalizedPath);
      navigate(normalizedPath, { replace: true });
      return;
    }

    // Détection de doubles préfixes de langue (ex: /en/en/ ou /fr/es/)
    const doubleLangPattern = /^\/(fr|en|es)\/(fr|en|es)\//;
    if (doubleLangPattern.test(currentPath)) {
      console.warn('⚠️ Double préfixe langue détecté:', currentPath);
      // Garder seulement le premier préfixe
      const cleanPath = currentPath.replace(doubleLangPattern, (match, lang1) => `/${lang1}/`);
      navigate(cleanPath, { replace: true });
      return;
    }

    // Détecter les URLs avec placeholders non remplacés
    if (currentPath.includes('{') || currentPath.includes('}') || 
        currentPath.includes('search_term_string') || 
        currentPath.includes('undefined')) {
      console.warn('❌ URL avec placeholder détecté:', currentPath);
      navigate('/', { replace: true });
      return;
    }

  }, [location.pathname, navigate]);

  // Ce composant ne rend rien
  return null;
};
